import _isEmpty from 'lodash/isEmpty';

import { Trans } from '@lyearn/i18n';

import fieldValidate from '../../helper/fieldValidate';
import {
  Field,
  FieldType,
  FieldValidationFunction,
  FieldValidationTypes,
  FormTextField,
} from '../../types';
import Input from '../text/Input';
import { FieldInputType } from '../types';

const fieldValidation: FieldValidationFunction<string> = {
  [FieldValidationTypes.Required]: ({ value, validation }) => {
    if (_isEmpty(value)) {
      return validation?.message || <Trans i18nKey="Form:FieldRequiredMessage" />;
    }
  },
  [FieldValidationTypes.Custom]: () => undefined,
};

const MultilineInputField: FieldInputType<FormTextField, string> = {
  Input,
  type: FieldType.Multiline,
  validate: (field, value, values) => {
    return fieldValidate({ field, value, values, fieldValidation });
  },
};

export default MultilineInputField;
